<template>
	<div class="soldout" :class="{ 'background-white': backgroundWhite }">
		<div>
			<button disabled class="btn btn-soldout">
				{{ buttonCopy }}
			</button>
			<button
				v-if="!showSubscription"
				@click="showSubscription = true"
				class="btn btn-soldout__notification"
			>
				Get notified when it comes back
			</button>
		</div>
		<div v-if="showSubscription">
			<form
				v-if="!subscribed"
				@submit.prevent="sendSubscription()"
				class="soldout__form"
			>
				<h3 class="soldout__form--heading">
					Sign up here to get notified when it comes back:
				</h3>
				<div>
					<input
						v-model="email"
						placeholder="Email Address"
						type="text"
						name="email"
						class="soldout__form--email"
						v-validate="'required|email'"
					>
					<span class="soldout__form--error">{{
						errors.first("email")
					}}</span>
				</div>
				<div class="soldout__form--subscription">
					<input
						type="checkbox"
						v-model="subscription"
						name="subscription"
						id="subscription"
					>
					<span
						class="subscribed"
					>Add me to the NZXT mailing list</span>
				</div>
				<button class="soldout__form--button">Sign Up</button>
			</form>
			<div v-else>
				<span>You have been added to our notify list. Stay tuned!</span>
			</div>
		</div>
	</div>
</template>

<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

const KLAVIYO_FIELDS = [
	"$source",
	"$email",
	"$subscription",
	"$consent_method",
	"$consent_form_id",
	"$consent_form_version"
];

export default {
	name: "SoldOutButton",
	props: {
		backgroundWhite: {
			type: Boolean,
			default: false
		}
	},
	data: () => {
		return {
			email: "",
			subscription: true,
			showSubscription: false,
			subscribed: false
		};
	},
	computed: {
		...mapState({
			h1KlaviyoEmbed: (state) => state.StarterPc.pageData.landing_page_sections[0]
		}),
		buttonCopy() {
			return this.$route.name == "h1-mini-pc" ? "Not Available" : "Sold out";
		}
	},
	methods: {
		async sendSubscription() {
			const isValid = await this.$validator.validateAll();

			if (!isValid) {
				return;
			}

			const formData = new FormData();
			formData.append("g", this.h1KlaviyoEmbed.klaviyo_embed);
			formData.append("$fields", KLAVIYO_FIELDS.join(","));
			formData.append("email", this.email);
			formData.append("subscription", this.subscription);

			axios({
				url:
                    "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
				method: "POST",
				data: formData,
				headers: { "Content-Type": "multipart/form-data" }
			}).then((response) => {
				this.subscribed = true;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.background-white {
    width: 70%;

    h3,
    span,
    input,
    span.subscribed {
        color: #444259 !important;
    }

    span.soldout__form--error {
        color: red !important;
    }

    .btn-soldout__notification {
        &:hover {
            border: 2px solid $orchid !important;
        }
    }
}

.soldout {
    font-family: "Akkurat-Normal";
    color: $white;
    width: 100%;

    &__form--heading {
        font-size: 16px;
        margin-top: 0px;
    }

    &__form--email {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid #87888a;
        border-radius: 8px;
        background: transparent;
        padding: 10px;
    }

    &__form--button {
        height: 32px;
        width: 122px;
        border-radius: 5px;
        background-color: #51007a;
        outline: none;
        border: none;
        margin-top: 20px;
    }

    &__form--subscription {
        display: flex;
        align-items: center;

        margin: 10px 0;

        input {
            margin-top: 0;
            margin-right: 10px;
        }

        span {
            margin-bottom: -4px;
        }
    }

    &__form--error {
        margin-top: 5px;
        display: block;
        color: red;
    }
}

.btn-soldout {
    background-color: rgba(#5f707f, 0.5);
    padding: 18px 63px;
    margin-bottom: 20px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    color: $white;
    font-size: 14px;
    border: none;
    border-radius: 5px;
    transition: all 0.4s ease;

    &__notification {
        background-color: $orchid;
        color: $white;
        width: 100%;

        &:hover {
            background-color: $white;
            color: $orchid;
        }
    }

    @media (max-width: 580px) {
        display: block;
        margin: 0 auto;
        width: 100%;
        margin-bottom: 16px;
    }
}
</style>